export const ROLE_MANAGE = 'role-manage'
export const SETUP = 'setup'
export const USER_ADD = 'user-add'
export const LICENSE_MANAGE = 'license-manage'
export const GROUP_MANAGE = 'group-manage'
export const BOARD_MANAGE = 'board-manage'
export const PUBLIC_MANAGE = 'public-manage'
export const TEMPLATES = 'templates'
export const DOCSOURCE_MANAGE = 'docsource-manage'
export const INCOMINGMAIL_MANAGE = 'incomingmail-manage'
